import {Box} from '@chakra-ui/react'
import {Link as ReachLink, useLocation} from 'react-router-dom'
import {useEffect, useRef} from 'react'

const NavOption =  ({path = "/", ...props}) => {
    const location = useLocation()
    const currentOption = useRef(null)

    const config = {
        bg: location.pathname === path ? "zpurple.500" : "zpurple.200",
        mb: location.pathname === path ? "0%" : "1%",
        bbr: location.pathname === path ? "0" : "15",
        ref: location.pathname === path ? currentOption : null,
    }

    const scrollToButton = (val) => {
        if(currentOption.current)
            currentOption.current.scrollIntoView({behavior: "smooth", block: "center", inline: "center"})
    } 

    useEffect(() => {
        scrollToButton()
    }, [])

    return (
        <Box
            {...props}
            mx="2"
            borderRadius="15"
            p="2"
            my="1%"

            bg={config.bg}
            mb={config.mb}
            borderBottomRadius={config.bbr}
            fontSize="1.125rem"
			color="white" 
            ref={config.ref}
            onClick={(e) => {scrollToButton(e)}}
        >   
            <ReachLink
                to={path}
            >
                {props.children}
            </ReachLink>
        </Box>
    )
}

export default NavOption